import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../context/auth/authContext";
import AlertContext from "../../context/alert/alertContext";
import "./Login.css";
import Tilt from "react-parallax-tilt";
//import { Link } from "react-router-dom";
import Alerts from "../../containers/layout/Alerts";

const Login = props => {
  //document.body.classList.remove("noMenu");
  const authContext = useContext(AuthContext);
  const alertContext = useContext(AlertContext);

  const { setAlert } = alertContext;
  const { login, error, clearErrors, isAuthenticate } = authContext;

  useEffect(() => {
    if (isAuthenticate) {
      props.history.push("/home");
    }

    if (error === "Invalid Credentials") {
      setAlert(error, "danger");
      clearErrors();
    } else if (error) {
      setAlert(error, "danger");
      clearErrors();
    }
    // eslint-disable-next-line
  }, [error, isAuthenticate, props.history]);
  useEffect(() => {
    document.getElementsByName("UserName")[0].focus();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const [user, setUser] = useState({
    UserName: "",
    Password: ""
  });

  const { UserName, Password } = user;

  const onChange = e => setUser({ ...user, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault();
    if (UserName === "" || Password === "") {
      setAlert("Please fill in all fields", "danger");
    } else {
      await login({
        UserName,
        Password
      }).then(function() {
        if (localStorage.token) {
          props.history.push("/home");
        }
      })
    }
  };
  return (
    <div className="limiter">
      <div className="container-login100">
        <div className="wrap-login100">
          <div className="limiter text-center">
            <Alerts />
          </div>
          <div className="text-center" style={{width: "100%"}}>
            <img src="/images/logo/WE_PRO_logo.png" alt="IMG" style = {{height: "108px", width: "auto"}} ></img>
          </div>
          {/* <h1 className="limiter text-center p-b-40">WE Pro</h1> */}
          <div className="login100-pic js-tilt" data-tilt>
            <Tilt>
              <img src="/images/logo/img-01.png" alt="IMG"></img>
            </Tilt>
          </div>

          <form className="login100-form validate-form" onSubmit={onSubmit}>
            <span className="login100-form-title">Member Login</span>

            <div className="wrap-input100 validate-input">
              <input
                className="input100"
                type="text"
                autoComplete="off"
                name="UserName"
                placeholder="UserName"
                value={UserName}
                onChange={onChange}
              />
              <span className="focus-input100"></span>
              <span className="symbol-input100">
                <i className="fa fa-user-o" aria-hidden="true"></i>
              </span>
            </div>

            <div
              className="wrap-input100 validate-input"
              data-validate="Password is required"
            >
              <input
                className="input100"
                type="password"
                autoComplete="off"
                name="Password"
                placeholder="Password"
                value={Password}
                onChange={onChange}
              />
              <span className="focus-input100"></span>
              <span className="symbol-input100">
                <i className="fa fa-lock" aria-hidden="true"></i>
              </span>
            </div>

            {/* <div className="text-right p-t-12">
                <a className="txt2" href="#">
                  Forgot Password?
                </a>
              </div> */}

            <div className="container-login100-form-btn">
              <button className="login100-form-btn" value="Login">
                Login
              </button>
            </div>

            {/* <div className="text-center p-t-15">
              <Link className="txt2" to="/register">
                Create your Account
              </Link>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
  //}
};

export default Login;
